var React = require('react');

require('./Checkbox.css');

class Checkbox extends React.Component {
    static defaultProps = {
        checked: false,
        disabled: false,
    };
    constructor(props) {
        super(props);
        this.state = {
            checked: props.checked,
        };

        this.handleChange = this.handleChange.bind(this);
    };

    handleChange(e) {
        this.setState({checked: e.target.checked});
        this.props.onCheckChange(e.target.checked);
    };

    render() {
        const id = Math.random().toString(36).substr(2, 9);
        return (
        <div className={ this.props.checked ? 'pubr-checkbox pubr-checkbox--checked' : 'pubr-checkbox' }>
            <input 
                type="checkbox"                
                checked={this.props.checked}
                disabled={this.props.disabled}
                onChange={this.handleChange}
                id={id}
            />
            <label htmlFor={id}>
                {this.props.label}                
            </label>
        </div>
        );
    }
}

module.exports = Checkbox;


// WEBPACK FOOTER //
// ./src/components/Checkbox.js